export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
		},
		{
			key: 'hora_inicio',
			type: 'text',
		},
		{
			key: 'hora_fin',
			type: 'text',
		},
	],
	singular_model_name_spanish: 'Turno Caja',
	plural_model_name_spanish: 'Turno Caja',
	create_model_name_spanish: 'Nuevo Turno Caja',
	text_delete: 'el',
}